export default __webpack_public_path__ + "static/media/not-approve.1a8b3e92.svg";